var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { assertEx } from '@xyo-network/sdk-xyo-js';
import { Mutex } from 'async-mutex';
import Cookies from 'js-cookie';
import md5 from 'md5';
import { PixelApi } from './Api';
import getSystemInfo from './getSystemInfo';
import Referrer from './Referrer';
import UniqueUserId from './UniqueUserId';
import UtmFields from './UtmFields';
class XyPixel {
    constructor(pixelId) {
        this.queue = [];
        this.cid = new UniqueUserId().id;
        this.queueMutex = new Mutex();
        this.pixelId = pixelId;
    }
    identify(email) {
        this.email = email;
        this.email_hash = email ? md5(email) : undefined;
    }
    updateFbId() {
        var _a;
        this.exids = Object.assign({
            fbc: Cookies.get('_fbc'),
            fbp: Cookies.get('_fbp'),
            ga: Cookies.get('_ga'),
            gclid: Cookies.get('_gclid'),
            rdt_uid: Cookies.get('rdt_uid'),
            scid: Cookies.get('_scid'),
            tt_sessionId: (_a = sessionStorage.getItem('tt_sessionId')) !== null && _a !== void 0 ? _a : undefined,
        });
    }
    tryFlushQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.queueMutex.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
                if (this.queue.length === 0)
                    return;
                const api = XyPixel.api;
                if (api) {
                    const events = this.queue;
                    this.queue = [];
                    try {
                        yield api.trackEvents(events);
                    }
                    catch (ex) {
                        if (events) {
                            //put it back since it failed
                            this.queue = this.queue.concat(events);
                        }
                        console.error(ex);
                    }
                }
            }));
        });
    }
    send(event, fields) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.updateFbId();
            const utm = XyPixel.utmFields().update();
            const referrer = new Referrer();
            this.queue.push(Object.assign({
                cid: this.cid,
                create_time: Date.now(),
                email_hash: (_a = this.email_hash) !== null && _a !== void 0 ? _a : undefined,
                event,
                exids: this.exids,
                fields,
                host: document.location.host,
                pathname: document.location.pathname,
                pixel: this.pixelId,
                referrer: referrer.toJson(),
                system: getSystemInfo(),
                utm,
            }));
            yield this.tryFlushQueue();
        });
    }
    static get instance() {
        return assertEx(this._instance, 'XyPixel uninitialized');
    }
    static init(pixelId) {
        this._instance = new XyPixel(pixelId);
        return this._instance;
    }
    static selectApi(api) {
        this.api = api;
    }
}
XyPixel.utmFields = () => {
    if (XyPixel.utmFieldsObj === undefined) {
        XyPixel.utmFieldsObj = new UtmFields();
    }
    return XyPixel.utmFieldsObj;
};
XyPixel.api = new PixelApi();
export default XyPixel;
//# sourceMappingURL=Pixel.js.map